import React from "react";
import '../../ChatApp.css';
import { ReactComponent as IconClose } from "../../images/svg/close.svg";
import { ReactComponent as ParticipantFull} from "../../images/svg/participant_full.svg";


function ParticipantFullDialog({ isOpen, onClose }) {

    if (!isOpen) return null;

    return (
  

        <div className="dialog-overlay">
            <div className="dialog-box dialog-box-participant-full">
                <span className="dialog-box-close" onClick={onClose}>
                    <IconClose/>
                </span>
                <div className="dialog-box-content">
                    <div className="dialog-box-content-participant-full">
                        <ParticipantFull/>
                        <h3>Unable to join this meeting</h3>
                        <p>Meeting maximum guest limit exceeded. <br/>
                        Please try again later.</p>
                    </div>
                </div>
                <div class="dialog-box-footer-participant-full">
                    <button onClick={onClose} aria-label="Okay" class="dialog-box-button-confirm" type="submit">Okay</button>
                </div>
                
            </div>
        </div>
    );
}

export default ParticipantFullDialog;
